var map = {
	"./example-bg.svg": "da65",
	"./logo-dark.svg": "2224",
	"./logo-light.svg": "ea65",
	"./placeholder.png": "5b4d",
	"./solar-system.svg": "4361",
	"./sun-and-planet.svg": "8b15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";